import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Check } from "react-feather";
import { useForm } from "react-hook-form";
import { addDrone, getalldrones } from "../../api/dronesAPI";
import TextField from "../../components/UI/TextField";
import { useAuthStore } from "../../store/authStore";
import { useMapStore } from "../../store/mapStore";
import { useNavigate } from "react-router-dom";
import { droneCategory } from "../../helpers/constants";
import { ToastContainer, toast } from "react-toastify";
import DroneImageUpload from "./imageUploader";

const AddDronesPage = () => {
  const navigate = useNavigate();
  const qClient = useQueryClient();
  // get auth token
  const { token, setLoaderState, setToken } = useAuthStore((state) => state);
  const [images, setImages] = useState([])
  // get drones from api


  const { setUserDronesIdsStore, userDronesIdsStore } = useMapStore((state) => state)
  // add drone
  // const { DroneQuery.mutate, DroneQuery.isSuccess } = 
  const DroneQuery = useMutation({
    mutationFn: addDrone,
    onSuccess: () => {
      // refetch on submit
      qClient.invalidateQueries({ queryKey: "getDrones" });
    },
  });
  // form for add drone
  const {
    register,
    handleSubmit,
    getValues,
    reset,
    formState: { errors },
  } = useForm();
  // form submit handler
  const submitDrone = () => {
    let payload = getValues();
    payload = { ...payload, purchaseDate: new Date(payload.purchaseDate).valueOf() };
    let fd = new FormData()
    images.map((file, i) => fd.append(`file${i}`, file))
    fd.append("droneBody", JSON.stringify(payload))
    // console.log(fd, "<<<", images);
    // fd.append("payload", payload)

    DroneQuery.mutate({ token, fd });
    // reset();
  };
  const { data, error } = useQuery({
    queryFn: getalldrones,
    queryKey: ["getDrones", token, "approved"],
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (DroneQuery.isLoading) {
      setLoaderState(true)
    }
  }, [DroneQuery.isLoading])

  useEffect(() => {
    if (DroneQuery?.error?.response?.data?.message) {
      toast.error(DroneQuery?.error?.response?.data?.message)
      setLoaderState(false)
    }
  }, [DroneQuery.error])

  useEffect(() => {
    if (DroneQuery?.data?.data?.success) {
      // setToken(DroneQuery?.data?.data)
      // setImages([])
      setToken(DroneQuery?.data?.data?.data?.token)
      toast.error("success", DroneQuery?.data?.data?.message)
      setUserDronesIdsStore(data?.data?.data?.droneId)
      navigate("/dashboard/")
    }
    setLoaderState(false)
  }, [DroneQuery.isSuccess])

  useEffect(() => {
    const mappingDroneId = data?.data?.data?.map((drone) => {
      return drone.droneId
    })
    setUserDronesIdsStore(mappingDroneId)
  }, [data])

  const validateDate = (value) => {
    const curDate = new Date().getTime();
    const selectedDate = new Date(value).getTime();
    if (selectedDate > curDate) {
      toast.error("Enter Valid Purchase Date")
      return false;
    }
  };
  const validateUin = (value) => {
    if (value.length < 14) {
      return true
    } else {
      toast.error("Please Enter valid uin")
      return false;
    }
  }
  return (
    <div className="p-4">
      <ToastContainer />
      <div className="flex justify-between items-center">
        <h1 className="text-4xl w-full h-full">Add Drone</h1>
        <div className="flex">
          <button
            onClick={handleSubmit(submitDrone)}
            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl mr-3"
          >
            <Check /> &ensp; Save
          </button>
          <button
            onClick={() => navigate("/dashboard/")}
            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
          >
            View Drones
          </button>
        </div>
      </div>
      <br />
      <hr />
      <div className="grid grid-cols-2">
        <div>
          <form
            onSubmit={handleSubmit(submitDrone)}
            className="grid grid-cols-2 gap-2 mt-10"
          >
            <TextField
              placeholder={"Add a name"}
              label="Drone Name*"
              inputProps={{
                ...register("droneName", { required: true })
              }}
            />
            <TextField
              placeholder={"Add UIN number"}
              label="UIN*"
              inputProps={{ ...register("uin", { required: true, validate: validateUin }) }}
            />
            <TextField
              placeholder={"Add Purchase date"}
              label="Purchase Date*"
              type="date"
              inputProps={{
                ...register("purchaseDate", {
                  required: true,
                  validate: validateDate
                })
              }}
            />
            <span>
              <h2 className="text-tblu">Drone Category*</h2>
              <select
                {...register("droneCategory", { required: true })}
                className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none "
              >
                {droneCategory.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </span>
            <TextField
              placeholder={"Add Drone Height"}
              label="Drone Height (in meter)*"
              type="number"
              inputProps={{ ...register("height", { required: true }) }}
            />
            <TextField
              placeholder={"Add Drone Width"}
              label="Drone Width (in meter)*"
              type="number"
              inputProps={{ ...register("width", { required: true }) }}
            />
            <TextField
              placeholder={"Add Drone Length"}
              label="Drone Length (in meter)*"
              type="number"
              inputProps={{ ...register("length", { required: true }) }}
            />
            <TextField
              placeholder={"Add Drone Weight"}
              label="Drone Weight (in kgs)*"
              type="number"
              inputProps={{ ...register("totalWeight", { required: true }) }}
            />
            <TextField
              placeholder={"Add Drone Max Speed"}
              label="Drone MaxSpeed (in m/s)*"
              type="number"
              inputProps={{ ...register("maxSpeed", { required: true }) }}
            />
            <TextField
              placeholder={"Add Drone Crusing Speed"}
              label="Drone Crusing Speed (in m/s)*"
              type="number"
              inputProps={{ ...register("crusingSpeed", { required: true }) }}
            />
            <TextField
              placeholder={"Add Drone Endurance"}
              label="Drone Edurance (in minutes)*"
              type="number"
              inputProps={{ ...register("endurance", { required: true }) }}
            />
          </form>
        </div>

        <div className="grid grid-cols-2 ml-4 gap-5 mt-10">
          <DroneImageUpload droneImages={setImages} view={"Top"} index={0} />
          <DroneImageUpload droneImages={setImages} view={"Side"} index={1} />
          <DroneImageUpload droneImages={setImages} view={"Front"} index={2} />
          <DroneImageUpload droneImages={setImages} view={"Rear"} index={3} />
        </div>
      </div>

    </div>
  );
};

export default AddDronesPage;
